import axios from 'axios';

const getBaseURL = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  const origin = window.location.origin;
  // If we're on 3000 (frontend default), the backend is likely on 8080
  if (origin.includes(':3000')) {
    return origin.replace(':3000', ':8080') + '/api';
  }
  // Otherwise, assume /api prefix on current origin
  return `${origin}/api`;
};

const api = axios.create({
  baseURL: getBaseURL(),
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    console.log(`[API REQUEST] ${config.method.toUpperCase()} ${config.url}`);
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Only globally auto-logout on 401s if it's a core auth check or explicitly unauthorized logic
    // We avoid global logouts for secondary requests (like polling/SSE or background fetching) 
    // to prevent aggressive session timeouts.
    if (error.response?.status === 401 &&
      !window.location.pathname.includes('/login') &&
      !window.location.pathname.includes('/register')) {

      // Check if it's a critical path that warrants a full session clear
      const url = error.config?.url || '';
      const isCriticalAuthPath = url.includes('/auth/') || url.includes('/user/profile');

      if (isCriticalAuthPath && !window.isRedirectingToLogin) {
        window.isRedirectingToLogin = true;
        // Commented out the aggressive alert to improve UX:
        // alert("Your session has expired. Please log in again.");
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login?session_expired=true';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
